<div class="location-selection-container" *ngIf="selectedCategory">
    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'request_v2.location-selection.title' | translate }}</h2>
    </div>

    <div class="selected-category-container">
        <div class="selected-category-display">
            <div class="category-header">
                <i [class]="(selectedCategory.icon || 'icon-map-marker') + ' category-icon'"></i>
                <h3 class="category-title">{{ selectedCategory?.name }}</h3>
            </div>
            <p *ngIf="selectedSubcategory" class="subcategory-title">{{ selectedSubcategory?.name }}</p>
        </div>
    </div>

    <!-- Add Leaflet CSS -->
    <link
      rel="stylesheet"
      href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
      integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
      crossorigin=""
    />
    
    <div class="map-container" #mapContainer>
        <div id="map" class="map-canvas"></div>

        <div class="map-error" *ngIf="mapError">
            <div class="map-error-content">
                <i class="icon-error"></i>
                <p>{{ 'request_v2.location-selection.map-error' | translate }}</p>
            </div>
        </div>
    </div>

    <!-- TODO: When request promotions are available -->
    <!-- <div class="request-promotion-card">
    <div class="request-promotion-image">
      <img src="" alt="Maintenance report">
    </div>
    <div class="request-promotion-content">
      <h3 class="request-promotion-title">{{ 'request_v2.location-selection.promotion.title' | translate }}</h3>
      <p class="request-promotion-text">{{ 'request_v2.location-selection.promotion.description' | translate }}</p>
    </div>
  </div> -->

    <div class="location-instructions">
        <h3 class="location-title">{{ 'request_v2.location-selection.instructions.title' | translate }}</h3>
        <p class="location-subtitle">{{ 'request_v2.location-selection.instructions.subtitle' | translate }}</p>
    </div>

    <div class="location-search-container">
        <div class="search-input-wrapper">
            <i class="icon-search search-icon"></i>
            <input
                type="text"
                class="search-input"
                [formControl]="searchControl"
                placeholder="{{ 'request_v2.location-selection.search-placeholder' | translate }}"
                [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayAddressFn" (optionSelected)="addressSelected($event.option.value)">
                <mat-option *ngFor="let address of addressSuggestions | async" [value]="address">
                    {{ formatAddress(address) }}
                </mat-option>
                <mat-option *ngIf="(addressSuggestions | async)?.length === 0 && searchControl.value?.length > 3" [disabled]="true">
                    <div class="no-results">
                        <p class="no-results-title">{{ 'request_v2.location-selection.no-results.title' | translate }}</p>
                        <p class="no-results-description">{{ 'request_v2.location-selection.no-results.description' | translate }}</p>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>

    <div class="location-options-container">
        <div
            *ngFor="let option of displayLocationOptions"
            class="location-option-item"
            [ngClass]="{ selected: option.selected }"
            (click)="selectLocationOption(option)"
            [ngStyle]="{ display: option.display ? 'block' : 'none' }"
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between"
        >
            <div class="location-option-radio" style="flex: 1; display: flex; align-items: center">
                <input type="radio" [id]="'location-' + option.id" [name]="'location'" [checked]="option.selected" />
                <label [for]="'location-' + option.id">
                    <span class="location-option-name">{{ 'request_v2.location-selection.location-options.' + option.id | translate }}</span>
                    <span *ngIf="option.id === 'none'" class="location-option-address">{{ 'request_v2.location-selection.proceed-without-address' | translate }}</span>
                    <span *ngIf="option.address" class="location-option-address">{{ option.address }}</span>
                </label>
                <mat-icon *ngIf="option.type === 'actual'" class="location-refresh-button" style="margin-left: 12px; align-self: center">my_location</mat-icon>
            </div>
        </div>
    </div>

    <div class="entire-street-container" *ngIf="hasLocationSelected && currentlySelectedLocation?.type !== 'none'" style="margin-top: 16px;">
        <mat-checkbox [(ngModel)]="entireStreet" color="primary">
            {{ 'request_v2.location-selection.entire-street' | translate }}
        </mat-checkbox>
    </div>
</div>
